import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;
export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-weight: bold;
`;
export const RowTitleText = styled.h2`
  color: #474747;
  font-size: 28px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: -3px;
  font-weight: bold;
`;
export const WrapperStatus = styled.div`
  justify-self: end;
`;

export const ContactDetail = styled.div`
  margin-left: -137px;
  width: 208%;
  padding: 10px;
`;

export const ButtonData = styled(BaseButton)`
  background: #05719a;
  border: 1px solid #05719a;
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;
export const CompanyDetail = styled.div`
  justify-self: start;
  font-size: 14px;
  font-style: italic;
  margin-bottom: 10px;
`;

export const ButtonInfo = styled(BaseButton)`
  background: ${(props) => props.color ?? "#368939"};
  border: ${(props) => props.border ?? "1px solid #368939"};
  font-weight: normal;
`;

export const CommunicationDetail = styled.div`
  margin-top: 25px;
`;

export const ContactInformation = styled.div`
  margin-bottom: 15px;
  color: #000000;
  text-decoration-line: ${(props) => props.textDecoration ?? "none"};
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
`;

export const CommunicationOuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: bold;
  margin-bottom: 2rem
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const ButtonWrapper = styled.div`
  padding: 1.375rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FlexEndButtonWrapper = styled.div`
  justify-content: flex-end;
`;
export const FlexStartButtonWrapper = styled.div`
  justify-content: flex-start;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => props.gap ?? "1.25rem"};
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#004c7f"};
  font-size: ${(props) => props.fontSize ?? "14px"}
  font-weight:${(props) => props.fontWeight ?? "400"}
  padding: ${(props) => props.padding ?? "0px"};
`;